import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { MDCTextField } from '@material/textfield';
import { MDCTextFieldHelperText } from '@material/textfield/helper-text';

class Filters extends Component {
  constructor(props) {
    super(props);
    const { institutions, sectors, applyFilters } = props;
    this.institutionOptions = institutions.map(item => ({
      value: item,
      label: item,
    }));
    this.sectorOptions = sectors.map(item => ({
      value: item,
      label: item,
    }));

    this.allItems = {
      value: 'Todos',
      label: 'Todos',
    };

    const initialValues = {
      text: null,
      institution: [this.allItems],
      sector: [this.allItems],
    };

    this.institutionOptions.unshift(this.allItems);
    this.sectorOptions.unshift(this.allItems);

    // Get parameters from query.
    if (window.URLSearchParams) {
      const searchParams = new URLSearchParams(window.location.search);
      initialValues.text = searchParams.get('palabraClave');
      let institutionValue = searchParams.get('institucion');
      let sectorValue = searchParams.get('sector');
      if (institutionValue) {
        institutionValue = institutionValue.split(',');
        initialValues.institution = institutionValue.map(element => ({
          value: element,
          label: element,
        }));
      }
      if (sectorValue) {
        sectorValue = sectorValue.split(',');
        initialValues.sector = sectorValue.map(element => ({
          value: element,
          label: element,
        }));
      }
      applyFilters(
        initialValues.text,
        institutionValue,
        sectorValue,
      );
    }

    this.state = {
      institutionSelected: initialValues.institution,
      sectorSelected: initialValues.sector,
      textfieldValue: initialValues.text ? initialValues.text : '',
      showToggle: false,
      formHidden: false,
    };

    this.formSubmitted = this.formSubmitted.bind(this);
    this.filtersMq = this.filtersMq.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
    this.handleTextfieldChange = this.handleTextfieldChange.bind(this);
  }

  componentDidMount() {
    // Toggle filters in mobile.
    if (window.matchMedia) {
      const mq = window.matchMedia('(min-width: 768px)');
      mq.addListener(this.filtersMq);
      this.filtersMq(mq);
    }

    // Material for Fulltext textfield.
    /* eslint-disable */
    new MDCTextField(document.getElementById('filter-fulltext-field'));
    new MDCTextFieldHelperText(document.getElementById('filter-fulltext-field-input-helper-text'));
    /* eslint-enable */
  }

  filtersMq(mq) {
    if (mq.matches) {
      this.setState({
        showToggle: false,
        formHidden: false,
      });
    } else {
      this.setState({
        showToggle: true,
        formHidden: true,
      });
    }
  }

  handleSelectChange(newValue, property) {
    let toSave = [...newValue];
    if (!toSave.length) {
      // No items left, fallback to 'Todos'.
      toSave = [this.allItems];
    } else {
      const newAllIndex = newValue.findIndex(element => element.value === 'Todos');
      if (newAllIndex !== -1) {
        const oldValue = this.state[property]; // eslint-disable-line
        if (oldValue.find(element => element.value === 'Todos')) {
          // 'Todos' was already present, remove it.
          toSave.splice(newAllIndex, 1);
        } else {
          // 'Todos' is new. This should be the only value.
          toSave = [this.allItems];
        }
      }
    }
    const newState = {};
    newState[property] = toSave;
    this.setState(newState);
  }

  handleTextfieldChange(event) {
    this.setState({
      textfieldValue: event.target.value,
    });
  }

  formSubmitted(event) {
    event.preventDefault();
    let { institutionSelected, sectorSelected, textfieldValue } = this.state;
    textfieldValue = textfieldValue.trim();
    institutionSelected = institutionSelected.map(element => element.value);
    sectorSelected = sectorSelected.map(element => element.value);
    const { applyFilters } = this.props;
    applyFilters(textfieldValue, institutionSelected, sectorSelected);

    // Update URL query parameters.
    if (window.URLSearchParams) {
      const searchParams = new URLSearchParams(window.location.search);
      // Remove 'pagina' parameter, if present.
      searchParams.delete('pagina');
      if (textfieldValue) {
        searchParams.set('palabraClave', textfieldValue);
      } else {
        searchParams.delete('palabraClave');
      }
      if (institutionSelected.indexOf('Todos') === -1) {
        searchParams.set('institucion', institutionSelected);
      } else {
        searchParams.delete('institucion');
      }
      if (sectorSelected.indexOf('Todos') === -1) {
        searchParams.set('sector', sectorSelected);
      } else {
        searchParams.delete('sector');
      }
      let searchString = searchParams.toString();
      searchString = searchString ? `?${searchString}` : '';
      window.history.pushState(null, null, `${window.location.pathname}${searchString}`);
    }
  }

  toggleForm() {
    const { formHidden } = this.state;
    this.setState({
      formHidden: !formHidden,
    });
  }

  render() {
    const {
      institutionSelected,
      sectorSelected,
      showToggle,
      formHidden,
      textfieldValue,
    } = this.state;
    const selectStyles = {
      control: base => ({
        ...base,
        minHeight: '55px',
      }),
      multiValue: base => ({
        ...base,
        height: '40px',
      }),
      multiValueLabel: base => ({
        ...base,
        alignSelf: 'center',
      }),
    };
    const labelStyles = {
      WebkitFontSmoothing: 'antialiased',
      color: 'white',
      fontSize: '0.75rem',
      fontFamily: '"Open Sans", sans-serif',
      letterSpacing: '0.39996px',
      margin: 0,
    };
    const toggleButton = showToggle ? (
      <div className="technical-services-form__toggle-wrapper">
        <button
          type="button"
          onClick={this.toggleForm}
          className="btn btn-menu btn-radius text-general-white"
        >
          {formHidden ? 'Ver filtros' : 'Ocultar filtros'}
        </button>
      </div>
    ) : null;
    const formStyles = {
      display: formHidden ? 'none' : 'flex',
    };
    return (
      <div className="technical-services-form-wrapper">
        <form className="technical-services-form" onSubmit={this.formSubmitted} style={formStyles}>
          <div className="text-field-wrapper">
            <div
              className="mdc-text-field mdc-text-field--with-trailing-icon mdc-ripple-upgraded"
              id="filter-fulltext-field"
            >
              <input
                type="text"
                id="filter-fulltext-field-input"
                className="mdc-text-field__input"
                aria-controls="filter-fulltext-field-input-helper-text"
                aria-describedby="filter-fulltext-field-input-helper-text"
                value={textfieldValue}
                onChange={this.handleTextfieldChange}
              />
              <label htmlFor="filter-fulltext-field-input" className="mdc-floating-label"> {/* eslint-disable-line */}
                Escriba la palabra clave
              </label>
              <div className="mdc-line-ripple" />
            </div>
            <p
              id="filter-fulltext-field-input-helper-text"
              className="mdc-text-field-helper-text mdc-text-field-helper-text--persistent"
              aria-hidden="true"
            >
              Busque por palabra clave
            </p>
            <span className="text-field-icon-search" />
          </div>
          <div className="select-wrapper wrapper">
            <Select
              options={this.sectorOptions}
              value={sectorSelected}
              onChange={value => this.handleSelectChange(value, 'sectorSelected')}
              styles={selectStyles}
              id="technical-services-form-sector"
              isClearable={false}
              isMulti
              isSearchable
            />
            {/* eslint-disable-next-line */}
            <label htmlFor="technical-services-form-sector" style={labelStyles}>
              Sector de Aplicación
            </label>
          </div>
          <div className="select-wrapper wrapper">
            <Select
              options={this.institutionOptions}
              value={institutionSelected}
              onChange={value => this.handleSelectChange(value, 'institutionSelected')}
              styles={selectStyles}
              id="technical-services-form-institution"
              isClearable={false}
              isMulti
              isSearchable
            />
            {/* eslint-disable-next-line */}
            <label htmlFor="technical-services-form-institution" style={labelStyles}>
              Institución
            </label>
          </div>
          <div className="technical-services-form__submit">
            <input
              className="btn btn-menu btn-radius text-general-white"
              type="submit"
              value="Buscar"
            />
          </div>
        </form>
        {toggleButton}
      </div>
    );
  }
}

Filters.propTypes = {
  institutions: PropTypes.arrayOf(PropTypes.string).isRequired,
  sectors: PropTypes.arrayOf(PropTypes.string).isRequired,
  applyFilters: PropTypes.func.isRequired,
};

export default Filters;
